import { DateTime } from 'luxon';
import { AppThunk } from '../../../store/rootReducer';
import { setRulerTimeStarted } from '../actions/analytics-info.actions';
import { USE_RULER } from '../analytics.constants';
import { getBaseProperties, track } from '../analytics.utils';

export const trackUseRuler =
  (interaction: 'click' | 'keyboard', analyticsEventTrack = track): AppThunk =>
  (dispatch, getState) => {
    dispatch(setRulerTimeStarted({ timestamp: DateTime.now().toMillis() }));
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    analyticsEventTrack({
      name: USE_RULER,
      properties: {
        user_id: userId,
        ecg_id: ecgId,
        view,
        interaction,
      },
    });
  };
